const ADDITIONAL_RECEIVERS_LABEL_TEXT = 'Quem pode receber essa entrega?';
const ADDITIONAL_RECEIVERS_BUTTON_ID = 'aditional-receivers-action-button';

export { ADDITIONAL_RECEIVERS_BUTTON_ID, ADDITIONAL_RECEIVERS_LABEL_TEXT };
